import {Injectable} from '@angular/core';

@Injectable()
export class MandiriSyariahModel {
    public trx_datetime: any;
    public BillKey: any;
    public PayAmount: any;
}
